<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useConfirmStore } from '@/stores/confirm'
import AppModal from './AppModal.vue'

/**
 * Hôte des demandes de confirmation, monté UNE SEULE FOIS dans `App.vue` — à
 * côté de `ToastHost`. Les écrans appellent `confirm.ask(...)` et n'ont aucune
 * modale à déclarer.
 *
 * Le bouton d'action reçoit `data-autofocus` : c'est lui qui prend le focus à
 * l'ouverture, ce qui rend la confirmation validable d'un simple Entrée. Pour
 * une action DESTRUCTRICE, on pourrait préférer focaliser « Annuler » ; ce n'est
 * pas ce qui est fait, parce qu'un utilisateur qui vient de cliquer « Supprimer »
 * a déjà exprimé son intention, et que le bouton rouge signale suffisamment le
 * risque.
 */

const { t } = useI18n()
const confirmStore = useConfirmStore()

const ouvert = computed(() => confirmStore.courante !== null)
</script>

<template>
  <AppModal
    :open="ouvert"
    :title="confirmStore.courante?.title ?? ''"
    width="440px"
    @close="confirmStore.cancel()"
  >
    <p class="message">{{ confirmStore.courante?.message }}</p>

    <template #actions>
      <button class="btn btn-ghost" type="button" @click="confirmStore.cancel()">
        {{ confirmStore.courante?.cancelLabel ?? t('common.cancel') }}
      </button>
      <button
        class="btn"
        :class="confirmStore.courante?.danger ? 'btn-danger' : 'btn-primary'"
        type="button"
        data-autofocus
        @click="confirmStore.confirm()"
      >
        {{ confirmStore.courante?.confirmLabel ?? t('common.confirm') }}
      </button>
    </template>
  </AppModal>
</template>

<style scoped>
.message {
  margin: 0;
  /* `anywhere` : un message qui cite un titre d'élément très long sans espace
     déborderait sinon de la boîte. */
  overflow-wrap: anywhere;
}
</style>
